import React from 'react';

const baseSvgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
  focusable: false,
};

function StrokePath({ d, opacity = 1 }) {
  return (
    <path
      d={d}
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={opacity}
    />
  );
}

export function IconArrowLeft({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      <StrokePath d="M15 18l-6-6 6-6" />
    </svg>
  );
}

export function IconWheel({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      {/* Outer ring */}
      <StrokePath d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18Z" />

      {/* Spokes (secondary / duotone) */}
      <StrokePath d="M12 3v18" opacity={0.55} />
      <StrokePath d="M3 12h18" opacity={0.55} />
      <StrokePath d="M7.2 7.2l9.6 9.6" opacity={0.35} />
      <StrokePath d="M16.8 7.2l-9.6 9.6" opacity={0.35} />

      {/* Pointer/needle */}
      <StrokePath d="M12 12l3.5-1.5" />
      <circle cx="12" cy="12" r="1.1" fill="currentColor" opacity="0.95" />
    </svg>
  );
}

export function IconPuzzle({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      {/* Puzzle outline */}
      <StrokePath d="M9.5 7.2a2.3 2.3 0 1 1 4.6 0V9h1.2a2.3 2.3 0 1 1 0 4.6H14v1.2a2.3 2.3 0 1 1-4.6 0V13.6H8.2a2.3 2.3 0 1 1 0-4.6H9.5V7.2Z" />

      {/* Inner duotone details */}
      <StrokePath d="M12 9v4" opacity={0.35} />
      <StrokePath d="M10 11h4" opacity={0.35} />
    </svg>
  );
}

export function IconBasket({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      {/* Basket body */}
      <StrokePath d="M5 10l2 10h10l2-10H5Z" />

      {/* Handle */}
      <StrokePath d="M9 10l3-6 3 6" opacity={0.6} />

      {/* Weave line (secondary) */}
      <StrokePath d="M5.5 14h13" opacity={0.35} />
      <StrokePath d="M6.2 17h11.6" opacity={0.25} />
    </svg>
  );
}

export function IconCards({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      {/* Front card */}
      <StrokePath d="M8 7h11v13H8V7Z" />

      {/* Back card (secondary) */}
      <StrokePath d="M5 4h11v3" opacity={0.45} />
      <StrokePath d="M5 4v13h3" opacity={0.45} />

      {/* Heart */}
      <path
        d="M12.5 10.2c.8-.6 1.9-.6 2.7.1c.9.8.9 2.2 0 3l-2 1.9l-2-1.9c-.9-.8-.9-2.2 0-3c.8-.7 1.9-.7 2.7-.1Z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.95"
      />
    </svg>
  );
}

export function IconTicTacToe({ size = 20 }) {
  return (
    <svg width={size} height={size} {...baseSvgProps}>
      {/* Grid (secondary) */}
      <StrokePath d="M8 4v16" opacity={0.45} />
      <StrokePath d="M16 4v16" opacity={0.45} />
      <StrokePath d="M4 8h16" opacity={0.45} />
      <StrokePath d="M4 16h16" opacity={0.45} />

      {/* X mark */}
      <path
        d="M9.5 10.5l5 5m0-5l-5 5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.95"
      />
    </svg>
  );
}

